import { useLocalization } from "@progress/kendo-react-intl";

export const MyCommandCell = (props:any) => {
    const { dataItem, edit, update, cancel } = props;
    const inEdit = props.isInEdit;
    const nameField:any = dataItem.name;

    const localizationService = useLocalization();

    return (
      <td className="k-command-cell" 
        style={{textAlign: 'center'}}
      >
          {
            inEdit 
            ? 
              <button     
                id='check'     
                className="k-icon k-font-icon k-i-check" 
                style={{color: '#198792', margin: '8px', border:'none', background: 'none', outline: 'none'}}
                onClick={() =>
                  inEdit && nameField != ''
                    ? update(dataItem)
                    : edit(dataItem)
                }
              >
                <a 
                  id='check'                    
                  title={localizationService.toLanguageString('synoptic_devices.update_name', 'NOT_FOUND')}
                />      
              </button>                  
            :        
              <button          
                id='edit'
                className="k-icon k-font-icon k-i-pencil" 
                style={{color: '#198792', margin: '8px', border:'none', background: 'none', outline: 'none'}}
                onClick={() =>
                  inEdit && nameField != ''
                    ? update(dataItem)
                    : edit(dataItem)
                }
              >         
                <a 
                  id='edit'                  
                  title={localizationService.toLanguageString('synoptic_devices.edit_name', 'NOT_FOUND')} 
                />   
              </button>         
          }
        { inEdit ?
            <button
              id='close'
              className="k-icon k-font-icon k-i-close"  
              style={{color: '#198792', margin: '8px', border:'none', background: 'none', outline: 'none'}}
              onClick={() => cancel(dataItem)}
            >
              <a
                id='close'                
                title={localizationService.toLanguageString('synoptic_devices.cancel', 'NOT_FOUND')} 
              />
            </button>
        : null}
      </td>
    );
  };